@if (config()) {
  <div
    class="blocker-error-page d-flex flex-column w-100 justify-content-center align-items-center"
    [ngClass]="{
      'surface-high-contrast': !isUnavailableSystemError(),
      'surface-glass-high-contrast-invert elevation-overlay-blur': isUnavailableSystemError(),
    }"
  >
    <div class="p-minus">
      <common-network-error-image [type]="config()?.image"></common-network-error-image>
    </div>
    <div class="d-flex flex-column gap-small align-items-center">
      <div
        class="st-6"
        [ngClass]="{
          'text-oninvert-high': isUnavailableSystemError(),
          'text-onback-high': !isUnavailableSystemError(),
        }"
      >
        {{ config()?.title }}
      </div>
      <div
        [ngClass]="{
          'text-oninvert-medium': isUnavailableSystemError(),
          'text-onback-medium ': !isUnavailableSystemError(),
        }"
        class="b-2 px-big d-flex justify-center text-align-center"
        [innerText]="config()?.message"
      ></div>
    </div>

    @if (config()?.cta === 'RETRY') {
      <ngx-button
        [mode]="'section'"
        [style]="isUnavailableSystemError() ? 'tinted-on-back' : 'fill'"
        [size]="'medium'"
        [disabled]="disableButton()"
        [rightIcon]="{
          name: 'refresh',
          type: 'linear',
        }"
        class="mt-mega"
        (click)="handleRetry()"
      >
        تلاش دوباره
      </ngx-button>
    }
    @if (config()?.cta === 'RETURN_TO_HOME') {
      <ngx-button
        [mode]="'section'"
        [size]="'medium'"
        [disabled]="disableButton()"
        [leftIcon]="{
          name: 'arrow-left',
          type: 'linear',
        }"
        class="mt-mega"
        (click)="returnToHome()"
      >
        صفحه اصلی
      </ngx-button>
    }
  </div>
}
